import { FC, useEffect } from 'react'
import { Grid, SelectChangeEvent } from '@mui/material'

import { DateRange } from '@/components'

import { B2CPaymentsTypeSelect } from '../b2c-payments-type-select.tsx'
import { useB2CState } from '@/stores/slices/b2c-slice'
import { useAppDispatch } from '@/stores/hooks.ts'
import { b2cActions } from '@/stores/slices/b2c-slice/b2c-slice.ts'

export type B2CFormReport = {
  dateTo?: string
  dateFrom?: string
  payment_type?: string
}

type B2CDateRangeProps = {
  initialRange?: [string?, string?]
  onChange: (data: B2CFormReport) => void
}

export const B2CDateRange: FC<B2CDateRangeProps> = ({ onChange }) => {
  const { dateRange } = useB2CState()
  const { b2cPaymentsType: state } = useB2CState()
  const dispatch = useAppDispatch()

  const handleStatusChange = (event: SelectChangeEvent) => {
    dispatch(b2cActions.setFilter({ filterKey: 'b2cPaymentsType', filterValue: event.target.value }))
  }

  const selectValue = state || 'ALL'

  const handleDateChange = (value: [string?, string?]) => {
    dispatch(b2cActions.setFilter({ filterKey: 'dateFrom', filterValue: value[0] }))
    dispatch(b2cActions.setFilter({ filterKey: 'dateTo', filterValue: value[1] }))
  }

  useEffect(() => {
    onChange({ dateFrom: dateRange[0], dateTo: dateRange[1], payment_type: state !== 'ALL' ? state : undefined })
  }, [dateRange, state])

  return (
    <Grid container flexDirection="column" spacing={2}>
      <Grid item>
        <DateRange onChange={handleDateChange} initialRange={dateRange} />
      </Grid>
      <Grid item>
        <B2CPaymentsTypeSelect value={selectValue} onChange={handleStatusChange} />
      </Grid>
    </Grid>
  )
}
